export const J = {
    bg: '#0a1521',
    border: '0.5px solid #294766',
    muted: '#a3d1ff',
    accent: '#66b2ff',
    inputBg: '#0d1b2a',
    red: '#ff6b6b',
    green: '#6bffb8',
    tooltipBg: '#0d2a40',
    tooltipBorder: '#2a5a8c',
};

export const inputStyle = {
    background: J.inputBg,
    border: J.border,
    borderRadius: 3,
    color: J.accent,
    padding: '4px 8px',
    fontSize: 12,
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    width: '100%',
    boxSizing: 'border-box',
};

export const labelStyle = {
    color: J.muted,
    fontSize: 11,
    marginBottom: 3,
    display: 'flex',
    alignItems: 'center',
    gap: 5,
};
